export default __webpack_public_path__ + "static/media/zoomed_diagonalup_lighttodark.d70a9488.png";